module.exports = __webpack_public_path__ + "static/media/RememberStill.30af7b33.jpg";